<ng-container *ngIf="!(decided$ | async) && !hideForRoute">
  <div class="consent-overlay">
    <div class="consent-card glass-card">
      <div class="title-row">
        <p class="label">Tubify</p>
        <h2>Cookies</h2>
      </div>

      <p class="lead">
        Tubify uses essential cookies to function properly.
        If you allow advertising and analytics cookies, you help keep our service free.<br>
        
      </p>

      <!--div class="badges">
        <span class="badge">Essential · always on</span>
        <span class="badge subtle">Ads &amp; analytics · optional</span>
      </div-->

      <div class="actions">
        <ion-button class="futuristic-button" (click)="acceptAll()">Accept all</ion-button>
        <ion-button fill="outline" class="secondary customize-btn" (click)="rejectNonEssential()">
          Reject all
        </ion-button>
        <ion-button fill="outline" class="secondary reject-btn" (click)="toggleCustomize()">Customize</ion-button>
      </div>

      <div class="links">
        <a routerLink="/privacy">Privacy Policy</a>
        <button type="button" class="linkish" (click)="goToSettings()">Cookie settings</button>
      </div>

      <div class="customize" *ngIf="showCustomize">
        <div class="toggle-row">
          <div>
            <p class="pref-title">Advertising (Adsterra)</p>
            <p class="hint">Help Tubify with ads. No Spotify/YouTube data shared.</p>
          </div>
          <ion-toggle [(ngModel)]="preferences.ads" mode="ios"></ion-toggle>
        </div>
        <div class="toggle-row">
          <div>
            <p class="pref-title">Analytics</p>
            <p class="hint">Helps us improve Tubify with privacy-friendly metrics.</p>
          </div>
          <ion-toggle [(ngModel)]="preferences.analytics" mode="ios"></ion-toggle>
        </div>
        <ion-button class="futuristic-button" expand="block" (click)="savePreferences()">Save preferences</ion-button>
      </div>
    </div>
  </div>
</ng-container>
